import styled from 'styled-components';
import { BodyRegularS, HeadingExtraBoldS } from '../../../styles/globals';
import { IThemeProvider } from '../../../styles/theme';
import {
  NAME_CELL_WIDTH,
  DETAILS_CELL_WIDTH,
  TEAM_CELL_WIDTH,
  ROLE_CELL_WIDTH,
  DATA_CELL_WIDTH,
} from '../ReportsSetupParticipants.styles';
import AssignmentRemoveIcon from '@/assets/icons/assignment_remove.svg?react';
import PersonRemoveIcon from '@/assets/icons/person_remove.svg?react';

export const Container = styled.div`
  padding: 0 32px;
  height: 60px;
  display: flex;
  align-items: center;
  ${({ theme }: IThemeProvider) => `
    &:hover {
      background: ${theme.colors.primary[10]};

      #ActionIcons {
        display: flex;
      }
    }
  `}
`;

export const ActionIconsCont = styled.div`
  position: absolute;
  right: 0;
  margin: 0 16px 0 0;
  display: none;
`;

export const HalfCont = styled.div`
  display: flex;
  width: ${DETAILS_CELL_WIDTH};
`;

export const NameCont = styled.div`
  display: flex;
  flex-direction: column;
  width: ${NAME_CELL_WIDTH};
`;

export const Name = styled(HeadingExtraBoldS)`
  font-size: 18px;
  font-weight: 600;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 90%;
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const Data = styled(BodyRegularS)`
  font-size: 15px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: ${DATA_CELL_WIDTH};
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const Team = styled(Data)`
  width: ${TEAM_CELL_WIDTH};
`;

export const Role = styled(Data)`
  width: ${ROLE_CELL_WIDTH};
`;

export const DeleteParticipantIcon = styled(PersonRemoveIcon)`
  width: 20px;
  height: 20px;
  justify-self: flex-end;
  margin: auto 16px auto auto;
  cursor: pointer;
`;

export const DeleteTeamReportIcon = styled(AssignmentRemoveIcon)`
  width: 20px;
  height: 20px;
  justify-self: flex-end;
  margin: auto 16px auto auto;
  cursor: pointer;
`;
